import React, { useRef, useState }  from 'react';
import emailjs from '@emailjs/browser';
import { Footer } from '../../containers';
import { Navbar } from '../../components';
import './OmadaMonada.css';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import 'react-accessible-accordion/dist/fancy-example.css';
import OEFE from '../../assets/OEFE.jpg';
import labora from '../../assets/labora.jpg';
import edu4schools from '../../assets/edu4schools.png';
import ypourgeio from '../../assets/ypourgeio.jpg';
import checkmark from '../../assets/check-mark-button.svg';

const OmadaMonada = () => {
  const form = useRef();
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_ald9cce', 'template_optgjil', form.current, 'EVgIFCLIjxstCs_IK')
      .then((result) => {
          console.log(result.text);
          console.log("message sent");
          e.target.reset();
          setShowSuccess(true);
          setShowError(false);
      }, (error) => {
          console.log(error.text);
          setShowSuccess(false);
          setShowError(true);
      });
  };

  const closePopup = () => {
    setShowSuccess(false);
    setShowError(false);
  };
  return (
    <div className="OmadaMonada">
        <div className="gradient__bg">
          <Navbar className="navbar"/>
        </div>
        <div className="OmadaMonada__main-container">
          <div className="OmadaMonada__container">
            <div className="OmadaMonada__container-h">
              <h1>«Ομάδα ή Μονάδα»;</h1>
            </div>
            <div className="OmadaMonada__container-p">
              <p>&nbsp;&nbsp;&nbsp;Η προετοιμασία για τις Πανελλήνιες μέσα από ιδιαίτερα μαθήματα περιορίζεται στο γνωστικό επίπεδο του μαθητή, ο οποίος επαναπαύεται.</p>
              <p>&nbsp;&nbsp;&nbsp;Η συμμετοχή σε ένα ομοιογενές τμήμα, με ένα οργανωμένο και δοκιμασμένο πρόγραμμα, καλλιεργεί την άμιλλα και ωθεί τους μαθητές να δουλεύουν μεθοδικά και συστηματικά στα πλαίσια της ομάδας αναπτύσσοντας δυναμικά τις δικές τους δεξιότητες.</p>
              <p>&nbsp;&nbsp;&nbsp;Έτσι, επωφελούνται από τις γνώσεις αλλά και από τις απορίες των άλλων, αποκτούν αυτονομία και τελικά, αυτοπεποίθηση στις Εξετάσεις. Στις περιπτώσεις όπου είναι επιβεβλημένη η βοήθεια σε ατομικό επίπεδο, το φροντιστήριο προσφέρει τον δυναμικότερο συνδυασμό προκειμένου να πετύχει ο μαθητής το καλύτερο δυνατό αποτέλεσμα.</p>
              <p style={{ display: 'flex', alignItems: 'center' }}>
                <img src={checkmark} alt="CheckMark" style={{ width: '20px', height: '20px', marginRight: '5px' }} />
                ΣΥΜΜΕΤΕΧΩ...
              </p>
              <p>&nbsp;&nbsp;&nbsp;&bull;ενσωματώνομαι στην ομάδα</p>
              <p>&nbsp;&nbsp;&nbsp;&bull;συναγωνίζομαι και εξελίσσομαι</p>
              <p>&nbsp;&nbsp;&nbsp;&bull;διαδικτυακά αν χρειαστεί, μέσω διαδραστικών πινάκων</p>
              <p style={{ display: 'flex', alignItems: 'center' }}>
                <img src={checkmark} alt="CheckMark" style={{ width: '20px', height: '20px', marginRight: '5px' }} />
                ΜΑΘΑΙΝΩ...
              </p>
              <p>&nbsp;&nbsp;&nbsp;&bull;με σωστό οργανωμένο πρόγραμμα</p>
              <p>&nbsp;&nbsp;&nbsp;&bull;με πλούσιο διδακτικό υλικό</p>
              <p>&nbsp;&nbsp;&nbsp;&bull;με πρωτοποριακή διδασκαλία διαδραστικών πινάκων</p>
              <p style={{ display: 'flex', alignItems: 'center' }}>
                <img src={checkmark} alt="CheckMark" style={{ width: '20px', height: '20px', marginRight: '5px' }} />
                ΒΑΣΙΖΟΜΑΙ...
              </p>
              <p>&nbsp;&nbsp;&nbsp;&bull;σε έμπειρους καθηγητές</p>
              <p>&nbsp;&nbsp;&nbsp;&bull;σε στρατηγικό σχεδιασμό</p>
              <p>&nbsp;&nbsp;&nbsp;&bull;στην αξιοπιστία του Φροντιστηρίου</p>
              <p style={{ display: 'flex', alignItems: 'center' }}>
                <img src={checkmark} alt="CheckMark" style={{ width: '20px', height: '20px', marginRight: '5px' }} />
                ΑΞΙΟΛΟΓΟΥΜΑΙ...
              </p>
              <p>&nbsp;&nbsp;&nbsp;&bull;με βάση ατομικούς στόχους</p>
              <p>&nbsp;&nbsp;&nbsp;&bull;με τακτικά διαγωνίσματα</p>
              <p>&nbsp;&nbsp;&nbsp;&bull;με εναλλακτικά μέσα</p>
            </div>
          </div>
          <div className="OmadaMonada__side-Containers">
              <div className="OmadaMonada__side-Container1">
                <h1>Χρήσιμες Σελίδες</h1>
                <Accordion allowZeroExpanded allowMultipleExpanded preExpanded={['a']}>
                  <AccordionItem uuid="a">
                    <AccordionItemHeading>
                      <AccordionItemButton>
                        Σημεία Υπεροχής
                      </AccordionItemButton>
                    </AccordionItemHeading>
                      <AccordionItemPanel>
                        <p>
                        Το φροντιστήριο φημίζεται ως  το πιο οργανωμένο και φιλικό προς τους μαθητές του εκπαιδευτήριο. Σε συνδυασμό με την άψογη συνεργασία των καθηγητών του το καθιστά ένα από τα καλύτερα της περιοχής μας.
                        </p>
                        <a href="/Frontistirio/Paroxes-Ypiresiwn/" target="_blank" rel="noopener noreferrer">
                          <button class="custom-btn btn-5">Λεπτομέρειες</button>
                        </a>
                        </AccordionItemPanel>
                  </AccordionItem>
                    <AccordionItem>
                      <AccordionItemHeading>
                        <AccordionItemButton>
                        "Ομάδα ή Μονάδα" ;
                        </AccordionItemButton>
                      </AccordionItemHeading>
                        <AccordionItemPanel>
                          <p>
                          Το παιδί και ο έφηβος μαθαίνουν καλύτερα το «τι» και το «πως» μαζί με τους άλλους. “Learning together, learning to live together”  -UNESCO- 
                          </p>
                          <button class="custom-btn btn-5">Λεπτομέρειες</button>
                        </AccordionItemPanel>
                    </AccordionItem>
                    <AccordionItem>
                      <AccordionItemHeading>
                        <AccordionItemButton>
                        Πρόταση "ΑΝΟΔΟΥ" για Πανελλήνιες
                        </AccordionItemButton>
                      </AccordionItemHeading>
                        <AccordionItemPanel>
                          <p>
                          Οι υπεύθυνοι σπουδών του  φροντιστηρίου μας, μετά από τόσα χρόνια εμπειρίας είναι ικανοί  να προτείνουν την καλύτερη πρόταση ώστε να επιτύχει ο μαθητής  τον στόχο του.
                          </p>
                          <a href="/Mathimata/B-Lykeiou" target="_blank" rel="noopener noreferrer">
                            <button class="custom-btn btn-5">Λεπτομέρειες</button>
                          </a>
                        </AccordionItemPanel>
                    </AccordionItem>
                    <AccordionItem>
                      <AccordionItemHeading>
                        <AccordionItemButton>
                          Σχόλια Μαθητών
                        </AccordionItemButton>
                      </AccordionItemHeading>
                        <AccordionItemPanel>
                          <p>
                          Οι απόψεις των μαθητών μας για την λειτουργία του φροντιστηρίου αποτελούν κίνητρο για σκληρή και απαιτητική δουλειά, ωστόσο τα θετικά σχόλια είναι η ανταπόδοση όλων των προσπαθειών των καθηγητών μας . 
                          </p>
                          <a href="/PoioiEimaste/Oi-Mathites-Mas/" target="_blank" rel="noopener noreferrer">
                            <button class="custom-btn btn-5">Λεπτομέρειες</button>
                          </a>
                        </AccordionItemPanel>
                    </AccordionItem>
                </Accordion>
              </div>
              <div className="anodos__alykeiou-email-container">
              <form className="anodos__alykeiou-email-container_form" ref={form} onSubmit={sendEmail}>
                <h1 className="anodos__alykeiou-email-container_h1">Φόρμα Επικοινωνίας</h1>
                <label className="anodos__alykeiou-email-container_label">Όνομα</label>
                <input className="anodos__alykeiou-email-container_input" type="text" name="user_name" required/>
                <label className="anodos__alykeiou-email-container_label">Email</label>
                <input className="anodos__alykeiou-email-container_input" type="email" name="user_email" required/>
                <label className="anodos__alykeiou-email-container_label">Μήνυμα</label>
                <textarea className="anodos__alykeiou-email-container_input-message" name="message" required/>
                <input className="anodos__alykeiou-email-container_btn" type="submit" value="Αποστολή" />
              </form>

              {showSuccess && (
                <div className="anodos__alykeiou-email-container_popup anodos__alykeiou-email-container_popup--success">
                  <span>Your message was sent successfully!</span>
                  <button className="anodos__alykeiou-email-container_close" onClick={closePopup}>X</button>
                </div>
              )}

              {showError && (
                <div className="anodos__alykeiou-email-container_popup anodos__alykeiou-email-container_popup--error">
                  <span>There was an error sending your message. Please try again later.</span>
                  <button className="anodos__alykeiou-email-container_close" onClick={closePopup}>X</button>
                </div>
              )}
              </div>
            <div className="anodos__Alykeiou-links-container">
                <a href="https://www.oefe.gr/" target="_blank" rel="noopener noreferrer">
                    <div className="anodos__Alykeiou-links-container_box" style={{ backgroundImage: `url(${OEFE})` }}></div>
                </a>
                <a href="https://labora.gr/" target="_blank" rel="noopener noreferrer">
                    <div className="anodos__Alykeiou-links-container_box" style={{ backgroundImage: `url(${labora})` }}></div>
                </a>
                <a href="https://www.edu4schools.gr/" target="_blank" rel="noopener noreferrer">
                    <div className="anodos__Alykeiou-links-container_box" style={{ backgroundImage: `url(${edu4schools})` }}></div>
                </a>
                <a href="https://www.minedu.gov.gr/" target="_blank" rel="noopener noreferrer">
                    <div className="anodos__Alykeiou-links-container_box" style={{ backgroundImage: `url(${ypourgeio})` }}></div>
                </a>
            </div>
            </div>
            </div>
        <Footer />
    </div>
  )
}

export default OmadaMonada